import { render, staticRenderFns } from "./SpecialistHome.vue?vue&type=template&id=4fe4327b"
import script from "./SpecialistHome.vue?vue&type=script&lang=js"
export * from "./SpecialistHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports